import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const { t } = useLanguage();
  usePageMeta(`${t.notFound.title} | KAZIM'S`, t.notFound.body);
  return (
    <main className="flex min-h-screen items-center justify-center px-6 pt-32 pb-20">
      <div className="text-center">
        <p className="font-serif text-7xl italic text-gold/40" aria-hidden="true">404</p>
        <h1 className="mt-6 font-serif text-4xl text-cream">{t.notFound.title}</h1>
        <p className="mx-auto mt-4 max-w-md text-base text-cream/60">{t.notFound.body}</p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-10 inline-block bg-gold px-8 py-4 text-sm font-medium uppercase tracking-[0.15em] text-obsidian transition-all duration-300 hover:bg-gold-light"
        >
          {t.notFound.home}
        </Link>
      </div>
    </main>
  );
}
